import { UsersServiceInterface } from 'domain/services/users';
import {
  CreateUserUseCaseInterface,
  DeleteUserUseCaseInterface,
  GetAllUsersUseCaseInterface,
  GetUserByCpfUseCaseInterface,
  GetUserByIdUseCaseInterface,
  GetUsersOnlineInterface,
  GetUsersOnlineMapsInterface,
  UpdateUserUseCaseInterface,
} from 'domain/usecases';

interface UseCasesInjection {
  getAllUsers: GetAllUsersUseCaseInterface;
  createUser: CreateUserUseCaseInterface;
  updateUser: UpdateUserUseCaseInterface;
  deleteUser: DeleteUserUseCaseInterface;
  getUserById: GetUserByIdUseCaseInterface;
  getUserByCpf: GetUserByCpfUseCaseInterface;
  getUsersOnline: GetUsersOnlineInterface;
  getUsersOnlineMaps: GetUsersOnlineMapsInterface;
}

export class UsersService implements UsersServiceInterface {
  private readonly _getAllUsers: GetAllUsersUseCaseInterface;
  private readonly _createUser: CreateUserUseCaseInterface;
  private readonly _updateUser: UpdateUserUseCaseInterface;
  private readonly _deleteUser: DeleteUserUseCaseInterface;
  private readonly _getUserById: GetUserByIdUseCaseInterface;
  private readonly _getUserByCpf: GetUserByCpfUseCaseInterface;
  private readonly _getUsersOnline: GetUsersOnlineInterface;
  private readonly _getUsersOnlineMaps: GetUsersOnlineMapsInterface;

  constructor(usecases: UseCasesInjection) {
    this._getAllUsers = usecases.getAllUsers;
    this._createUser = usecases.createUser;
    this._updateUser = usecases.updateUser;
    this._deleteUser = usecases.deleteUser;
    this._getUserById = usecases.getUserById;
    this._getUserByCpf = usecases.getUserByCpf;
    this._getUsersOnline = usecases.getUsersOnline;
    this._getUsersOnlineMaps = usecases.getUsersOnlineMaps;
  }

  getAllUsers(
    params: GetAllUsersUseCaseInterface.Params,
  ): Promise<GetAllUsersUseCaseInterface.Result> {
    return this._getAllUsers.execute(params);
  }

  createUser(
    params: CreateUserUseCaseInterface.Params,
  ): Promise<CreateUserUseCaseInterface.Result> {
    return this._createUser.execute(params);
  }

  updateUser(
    params: UpdateUserUseCaseInterface.Params,
  ): Promise<UpdateUserUseCaseInterface.Result> {
    return this._updateUser.execute(params);
  }

  getUserById(
    params: GetUserByIdUseCaseInterface.Params,
  ): Promise<GetUserByIdUseCaseInterface.Result> {
    return this._getUserById.execute(params);
  }

  getUserByCpf(
    params: GetUserByCpfUseCaseInterface.Params,
  ): Promise<GetUserByCpfUseCaseInterface.Result> {
    return this._getUserByCpf.execute(params);
  }

  deleteUser(
    params: DeleteUserUseCaseInterface.Params,
  ): Promise<DeleteUserUseCaseInterface.Result> {
    return this._deleteUser.execute(params);
  }

  getUsersOnline(
    params: GetUsersOnlineInterface.Params,
  ): Promise<GetUsersOnlineInterface.Result> {
    return this._getUsersOnline.execute(params);
  }

  getUsersOnlineMaps(
    params: GetUsersOnlineMapsInterface.Params,
  ): Promise<GetUsersOnlineMapsInterface.Result> {
    return this._getUsersOnlineMaps.execute(params);
  }
}
